const state = {
  userInfo:{},
  shopCartNum:0,
  showSearch:true,
  registerId:'',
  linkSrc:'',
  avatar:'',
  enterTime:0,
  leaveTime:0,
  keyword:''
}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js